import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EthAddressDirective } from '@/directives/auction-house/eth-address.directive';

import { WeiPipe } from '@/pipes/auction-house/wei.pipe';

import { GlobalState } from '@/models/auction-house/state';
import { StarterBidPipe } from '@/pipes/auction-house/starter-bid';
import { AuctionDataService } from '@/services/auction-house/data.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    EthAddressDirective,

    WeiPipe,
    StarterBidPipe
  ],
  selector: 'app-bid-history',
  templateUrl: './bid-history.component.html',
  styleUrls: ['./bid-history.component.scss']
})

export class BidHistoryComponent implements OnInit {

  @Input() activeAuction!: GlobalState['dataState']['activeAuction'];

  viewAllBids!: boolean;

  etherscanLink: string = `https://etherscan.io`;

  constructor(
    public dataSvc: AuctionDataService
  ) {}

  ngOnInit(): void {}

}
